import {fabric} from 'fabric'
export function makeRectangle(canvas, options) {

    var rectangle, isDown, origX, origY;
    const {borderColor = `#000000`, fillColor, strokeWidth} = options;

    canvas.on('mouse:down', function(o){
        var pointer = canvas.getPointer(o.e);

        isDown = true;
        origX = pointer.x;
        origY = pointer.y;

        let options:any = {
            left: origX,
            top: origY,
            fill: fillColor?fillColor:'transparent',
            stroke: borderColor
        }
        if(strokeWidth) {
            options.strokeWidth = strokeWidth;
            options.strokeDashArray = [5, 5]; 
        }
        rectangle = new fabric.Rect(options);
        canvas.add(rectangle);
    });

    canvas.on('mouse:move', function(o){
        if (!isDown) return;
        var pointer = canvas.getPointer(o.e);
        if(origX>pointer.x){
            rectangle.set({ left: Math.abs(pointer.x) });
        }
        if(origY>pointer.y){
            rectangle.set({ top: Math.abs(pointer.y) });
        }

        rectangle.set({ width: Math.abs(origX - pointer.x) });
        rectangle.set({ height: Math.abs(origY - pointer.y) });
        canvas.renderAll();
    });

    canvas.on('mouse:up', function(o){
        rectangle.setCoords();
        isDown = false;
    });
}